export default __webpack_public_path__ + "static/gameChanger-6ee0205cdb81dd7df5c5de0aa0713617.png";